var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollapse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "collapse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4583 12.5C16.4583 12.1549 16.1784 11.875 15.8333 11.875H12.4999C12.1547 11.875 11.8749 12.1549 11.8749 12.5V15.8334C11.8749 16.1786 12.1547 16.4584 12.4999 16.4584C12.8451 16.4584 13.1249 16.1786 13.1249 15.8334V14.0089L16.2246 17.1086C16.4687 17.3527 16.8645 17.3527 17.1085 17.1086C17.3526 16.8646 17.3526 16.4688 17.1085 16.2248L14.0088 13.125H15.8333C16.1784 13.125 16.4583 12.8452 16.4583 12.5Z",
    fill: "#AFAEBA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.54159 12.5C3.54159 12.1549 3.82141 11.875 4.16659 11.875H7.49992C7.8451 11.875 8.12492 12.1549 8.12492 12.5V15.8334C8.12492 16.1786 7.8451 16.4584 7.49992 16.4584C7.15474 16.4584 6.87492 16.1786 6.87492 15.8334V14.0089L3.77519 17.1086C3.53112 17.3527 3.13539 17.3527 2.89131 17.1086C2.64723 16.8646 2.64723 16.4688 2.89131 16.2248L5.99103 13.125H4.16659C3.82141 13.125 3.54159 12.8452 3.54159 12.5Z",
    fill: "#AFAEBA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4583 7.50004C16.4583 7.84522 16.1784 8.12504 15.8333 8.12504H12.4999C12.1547 8.12504 11.8749 7.84522 11.8749 7.50004V4.16671C11.8749 3.82153 12.1547 3.54171 12.4999 3.54171C12.8451 3.54171 13.1249 3.82153 13.1249 4.16671V5.99116L16.2246 2.89143C16.4687 2.64735 16.8645 2.64735 17.1085 2.89143C17.3526 3.13551 17.3526 3.53124 17.1085 3.77532L14.0088 6.87504H15.8333C16.1784 6.87504 16.4583 7.15486 16.4583 7.50004Z",
    fill: "#AFAEBA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.54159 7.50004C3.54159 7.84522 3.82141 8.12504 4.16659 8.12504H7.49992C7.8451 8.12504 8.12492 7.84522 8.12492 7.50004V4.16671C8.12492 3.82153 7.8451 3.54171 7.49992 3.54171C7.15474 3.54171 6.87492 3.82153 6.87492 4.16671V5.99116L3.77519 2.89143C3.53112 2.64735 3.13539 2.64735 2.89131 2.89143C2.64723 3.13551 2.64723 3.53124 2.89131 3.77532L5.99103 6.87504H4.16659C3.82141 6.87504 3.54159 7.15486 3.54159 7.50004Z",
    fill: "#AFAEBA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapse);
export default __webpack_public_path__ + "static/media/collapse.b1d65d8e61f9f8c021d7076125626db7.svg";
export { ForwardRef as ReactComponent };